export enum DefectStatus {
  Outstanding = 'OUTSTANDING',
  Handled = 'HANDLED',
  Unhandled = 'UNHANDLED',
  NotApplicable = 'NOT_APPLICABLE',
}
